export default __webpack_public_path__ + "static/media/Retail.9c9092af.png";